import React, { ReactNode } from 'react';
const DetailsCard = ({ children, title }: { children?: ReactNode; title: string }) => {
  return (
    <div className='border py-3 border-gray-2 rounded-t-lg px-5 break-all'>
      <p className=' text-sm text-[#858585] pb-2-'>{title}</p>
      {children}
    </div>
  );
};

export default DetailsCard;
